import React from "react";
import "react-quill/dist/quill.snow.css";
import Paper from "@mui/material/Paper";
import ReactQuill from "react-quill";

const TextEditor = ({ value, onChange }) => {
  console.log("value",value)
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ size: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ color: [] }, { background: [] }],
      [{ direction: "rtl" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <Paper>
      <ReactQuill
        modules={modules}
        value={value}
        onChange={onChange}
        theme="snow"
        style={{
          zIndex: "999999",
          minHeight: 250,
        }}
      />
    </Paper>
  );
};

export default TextEditor;
